/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import axios from 'axios'

import {
  getRegionAll,
  getFilterCity,
  getSalesOrgAll,
  getRoleList,
  getLevelAll,
  getSectorList,
  getUserDetail,
  getLevelList,
  getDetailRole,
  getUserLevelSorg,
  getCusGrup,
} from '../../../api/modules/master-data/master_2'
import {getMaterialGroup} from '../../../api/modules/master-data/master'
import Pagination from '../component/Pagination'
import {MultiSelect} from 'react-multi-select-component'
import swal from 'sweetalert'
import {getAccessesUser} from '../../../api/modules/access/access'
import CustomUseEffect from '../component/CustomUseEffect'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {objToParams} from '../../../utils/objToParams'
import {fetchUsers, headers} from '../../../services/fetcher'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetFilterUser,
  setFilterUser,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../hooks/useRowTable'
import * as TableUI from '../../../components/Table/Table'
import {StyledCard} from '../../../components/StyledCard'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector, setAuthUser, setCredential} from 'src/redux/slices/authSlices'
import { downloadTemplate, importUser } from 'src/api/modules/users/user'
import { InputFile } from 'src/app/components/InputFile'
import { checkToken, loginAs } from 'src/api/modules/auth'
import { setToken } from 'src/_metronic/redux/content'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

type Props = {
  className: string
}

const TableUser: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterUser} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const dispath = useDispatch()
  const hakAkses = HakAkses()
  const navigate = useNavigate()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 7,
    onReloadTable: () => handleResetTable(),
  })

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [users, setUsers] = useState<any>()
  const [region, setRegion] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingg, setLoadingg] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [salesOrg, setSalesOrg] = useState<any>()
  const [role, setRole] = useState<any>()
  const [sector, setSector] = useState<any>()
  const [material, setMaterial] = useState<any>()
  const [levelUser, setLevelUser] = useState<any>()
  const [level, setLevel] = useState<any>()
  const [isDownloadTemplate, setIsDownloadTemplate] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [files, setFiles] = useState({file: null})

  const handleUpload = async () => {
    setBtnLoading(true)
    const lang = i18next.language
    let file = files.file
    let formdata = new FormData()
    formdata.append('file', file!)
    await importUser(formdata, lang)
      .then((res: any) => {
        // console.log(res.data.data.message)
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          const inputfile = document.getElementById('upload') as HTMLInputElement
          inputfile!.value = ''
          setShowUpload(false)
          onFetchUsers()
          // setActived(!actived)
        })
      })
      .catch((err: any) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
    setBtnLoading(false)
  }

  const rowNumber = useMemo(() => {
    const per = filterUser?.per_page ?? 5
    return page * per - per
  }, [filterUser, page])

  const getRegion = async () => {
    setLoading(true)
    const res = await getRegionAll()
    const data = res.data?.data?.map((item: any) => ({
      label: item.value,
      value: item.id,
    }))
    setRegion(data)
    setLoading(false)
  }

  const [selected, setSelected] = useState([])
  const [option, setOption] = useState<any>()
  const [optionEdit, setOptionEdit] = useState<any>()
  const [getSaleses, setgetSaleses] = useState<any>([])
  const [accesses, setAccesses] = useState<any>()
  const [isError, setIsError] = useState(false)

  const onFetchUsers = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchUsers(filterUser)
      .then((res) => {
        const data = res.data.data
        setUsers(data?.data)
        setPage(data?.current_page)
        setNumberURL(data?.links)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterUser])

  useEffect(() => {
    const getSalesOrg = async () => {
      setLoading(true)
      const res = await getSalesOrgAll()
      const data = res.data.data
      setSalesOrg(data)
      setLoading(false)
    }

    const getRole = async () => {
      setLoading(true)
      const res = await getRoleList()
      setRole(res.data.data)
      setLoading(false)
    }

    const getSector = async () => {
      setLoading(true)
      const res = await getSectorList()
      setSector(res.data.data)
      setLoading(false)
    }

    const getMaterial = async () => {
      setLoading(true)
      const res = await getMaterialGroup()
      setMaterial(res.data.data)
      setLoading(false)
    }

    const getUserLevel = async () => {
      setLoading(true)
      const res = await getLevelList()
      setLevelUser(res.data.data)
      setLoading(false)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesUser(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    getMaterial()
    getSector()
    getRole()
    getSalesOrg()
    // getUser()
    getRegion()
    getUserLevel()
  }, [])

  const paginateNumber = async (number: any) => {
    try {
      setLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${number}&${objToParams(filterUser)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setUsers(data?.data)
      setPage(data?.current_page)
      setNumberURL(data?.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const [getname, setGetName] = useState('')
  const [getusername, setGetUsername] = useState('')
  const [getemail, setGetEmail] = useState('')
  const [getpassword, setGetPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [regions, setRegions] = useState<any>('')
  const [getregions, setGetRegions] = useState<any>([])
  const [sales, setSales] = useState<any>('')
  const [salesEdit, setSalesEdit] = useState<any>('')
  const [salesList, setSalesList] = useState<any>()
  const [salesListEdit, setSalesListEdit] = useState<any>()
  const [roles, setRoles] = useState('')
  const [levels, setLevels] = useState('')
  const [sectors, setSectors] = useState<any>([])
  const [materials, setMaterials] = useState<any>([])
  const [isUpload, setIsUpload] = useState(false)
  const [phone, setPhone] = useState('')
  const [editphone, setEditPhone] = useState('')
  const [isExport, setIsExport] = useState(false)
  const [isExport2, setIsExport2] = useState(false)
  const [fullSegment, setFullSegment] = useState<any>([])
  const [segments, setSegments] = useState<any>([])
  // let test = sectors.find((o : any) => o.value == 3)
  // console.log(test)
  const handleRegion = async (e: any) => {
    let arr: any = []
    setGetRegions([...e])
    const selectedRegion = [...e].map((item: any) => item.value)
    let getRegionValue = selectedRegion.join(',')
    arr.push(selectedRegion)
    setRegions(arr[0])
    await getFilterCity(getRegionValue).then((res: any) => {
      const data = res.data.data
      setOption(data)
    })
  }

  const selectedCity = selected.map((item: any) => item.value)
  const selectedSector = sectors.map((item: any) => item.value)
  const selectedMaterial = materials.map((item: any) => item.value)

  const clearState = () => {
    setGetName('')
    setGetUsername('')
    setGetEmail('')
    setGetPassword('')
    setConfirm('')
    setRegions('')
    setGetRegions([])
    setSales([])
    setSalesList([])
    setRoles('')
    setSectors([])
    setMaterials([])
    setPhone('')
    setSelected([])
  }

  const postUser = async () => {
    setBtnLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/users`,
        {
          name: getname,
          role_id: roles,
          sales_organizations: sales,
          regions: regions,
          cities: selectedCity,
          nama_pengguna: getusername,
          email: getemail,
          password: getpassword,
          password_confirmation: confirm,
          sectors: selectedSector,
          product_types: selectedMaterial,
          user_level_id: levels,
          mobile_number: '+62' + phone,
          position: position,
          lang: i18next.language,
          segments: segments.map((item: any) => item.value)
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        if (!response.data.error) {
          setIsUpload(true)
          clearState()
          handleClose()
          swal({
            title: `${t('user created successfully')}`,
            icon: 'success',
          }).then(() => {
            // getUser()
            onFetchUsers()
          })
        }
      })
      .catch((error) => {
        swal({
          title: error.response.data.message,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const deleteUser = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .delete(`${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/users/${id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((response) => {
              if (!response.data.error) {
                setIsUpload(true)
                swal({
                  title: `${t('user successfully deleted')}`,
                  icon: 'success',
                }).then(() => {
                  onFetchUsers()
                  setActived(!actived)
                })
              }
            })
            .catch((error) => {
              swal({
                title: `${t('Data Failed to Delete')}`,
                icon: 'error',
              })
            })
        }
      })
      .catch((error) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [loadingImpersonate, setLoadingImpersonate] = useState<any>(null)

  const impersonateUser = async (id: any) => {
    setLoadingImpersonate(id)
    await loginAs(id)
      .then(({data: resp}) => {
        if (!resp.data.error) {
          localStorage.setItem('impersonating_user_id', localStorage.getItem('user_code') || '')
          dispatch(setAuthUser(resp.data))
          localStorage.setItem('role-flag', resp.data.credential.role_flag)
          localStorage.setItem('user_code', resp.data.credential.username)
          localStorage.setItem('role_flagg', resp.data.credential.role_flag)
          localStorage.setItem('sector_ids', resp.data.credential.sector_ids)
          localStorage.setItem('email', resp.data.credential.email)
          // localStorage.setItem('name', resp.data.credential.name)
          if (resp.data.credential.role_flag == null)
            localStorage.setItem(
              'username',
              resp.data.credential.customer?.title != null
                ? resp.data.credential.customer?.title + ' ' + resp.data.credential.customer?.name
                : resp.data.credential.customer?.name
            )
          else localStorage.setItem('username', resp.data.credential.name)
          localStorage.setItem('user-id', resp.data.credential.user_id)
          localStorage.setItem('cust-code', resp.data.credential.customer_code)
          localStorage.setItem('cus-grup', resp.data.credential.customer_account_group)
          localStorage.setItem('cus-grupp', resp.data.credential.customer_account_group)
          localStorage.setItem('cust-group', resp.data.credential.customer_account_group)
          localStorage.setItem('user-segment', resp.data.credential.segments)
          localStorage.setItem('user-product-type', resp.data.credential.product_types)
  
          if (!resp.data.error) {
            localStorage.setItem('token', resp.data.access_token)
            checkToken(resp.data.access_token).then((res) => {
              dispatch(setCredential(res.data.credential))
              try{
                const test = atob(resp.data.credential)
                const temp = JSON.parse(test)
                localStorage.setItem('credential', test)
                localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
                localStorage.setItem('credential-decoded', test)
              }catch(e){}
            })
            if (!resp.data.accesses) {
              // console.log('ga punya')
            } else {
              localStorage.setItem('access', JSON.stringify(resp.data.accesses.role_accesses))
              localStorage.setItem('accesses', JSON.stringify(resp.data.accesses))
              // dispath(setAccesses(JSON.stringify(resp.data.accesses.role_accesses)))
            }
            dispath(setToken(resp.data.access_token))
            navigate('/dashboard')
        }
      }
    })
      .catch((error) => {
        swal({
          title: error.response?.data?.message || error.message,
          icon: 'error',
        })
      })
      .finally(() => {
        setLoadingImpersonate(null)
      })
  }

  const [editId, setEditId] = useState<any>('')
  const [editName, setEditName] = useState<any>('')
  const [editPosition, setiEditPosition] = useState<any>('')
  const [editUsername, setEditUsername] = useState<any>('')
  const [editEmail, setEditEmail] = useState<any>('')
  const [editRegion, setEditRegion] = useState<any>('')
  const [editCity, setEditCity] = useState<any>('')
  const [editSales, setEditSales] = useState<any>('')
  const [editRoles, setEditRoles] = useState<any>('')
  const [editRolesName, setEditRolesName] = useState<any>('')
  const [editLevel, setEditLevel] = useState<any>('')
  const [editLevelName, setEditLevelName] = useState<any>('')
  const [editSector, setEditSector] = useState<any>('')
  const [editProduct, setEditProduct] = useState<any>('')
  const [stringsales, setStringsales] = useState('')

  const getSegments = async () => {
    await getCusGrup(sectors.map((item: any) => item.value).join(",")).then((res) => {
      setFullSegment(res.data.data)
    })
  }
  const getSegmentsEdit = async () => {
    await getCusGrup(editSector.map((item: any) => item.value).join(",")).then((res) => {
      setFullSegment(res.data.data)
    })
  }

  const handleEdit = async (id: any) => {
    setEditId(id)
    handleShow1()
    setLoadingg(true)
    const res = await getUserDetail(id)

    const selectedRegion = res.data.data.regions.map((item: any) => ({
      value: item.id,
      label: item.region_name,
    }))
    const selectedRegionId = res.data.data.regions.map((item: any) => item.id)
    const selectedCity = res.data.data.cities.map((item: any) => ({
      value: item.id,
      label: item.city_name,
    }))
    // console.log("selected cities", res.data.data.cities)
    const selectedSector = res.data.data.sector_model.map((item: any) => ({
      value: item.id,
      label: item.name,
    }))
    const selectedProduct = res.data.data.product_type_model.map((item: any) => ({
      value: item.material_group,
      label: item.product_type,
    }))

    setPhone(res.data.data.mobile_number?.replace('+62', ''))
    setEditPhone(res.data.data.mobile_number?.replace('+62', ''))
    setEditName(res.data.data.name)
    setiEditPosition(res.data.data.position)
    setEditUsername(res.data.data.nama_pengguna)
    setEditEmail(res.data.data.email)
    setEditRegion(selectedRegion)
    setEditCity(selectedCity)
    setEditSales(res.data.data.sales_organization)
    setEditRoles(res.data.data?.role_id)
    setEditRolesName(res.data.data.role?.name)
    setEditSector(selectedSector)
    setEditProduct(selectedProduct)
    setEditLevel(res.data.data.user_level?.id)
    setEditLevelName(res.data.data.user_level?.name)
    setSegments(res.data.data.segments?.map((item: any) => {
      return {
        value: item,
        label: item
      }
    }))

    await getFilterCity(selectedRegionId).then((res: any) => {
      const data = res.data?.data
      setOptionEdit(
        data?.map((item: any) => ({
          value: item.id,
          label: item.value,
        }))
      )
    })

    setLoadingg(false)
  }

  const handleRegionEdit = async (e: any) => {
    setCounter(counter + 1)
    let arr: any = []
    setEditRegion([...e])
    const selectedRegion = [...e].map((item: any) => item.value)
    let getRegionValue = selectedRegion.join(',')
    arr.push(selectedRegion)
    setRegions(arr[0])
    await getFilterCity(getRegionValue).then((res: any) => {
      const data = res.data.data
      setOptionEdit(
        data.map((item: any) => ({
          label: item.value,
          value: item.id,
        }))
      )
    })
  }

  const editUser = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/users/${editId}`,
        {
          name: editName,
          role_id: editRoles,
          sales_organizations: editSales,
          regions: editRegion,
          cities: editCity,
          nama_pengguna: editUsername,
          email: editEmail,
          password: getpassword,
          password_confirmation: confirm,
          sectors: editSector,
          product_types: editProduct,
          user_level_id: editLevel,
          mobile_number: '+62' + editphone,
          position: editPosition,
          lang: i18next.language,
          segments
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('User edited successfully')}`,
          icon: 'success',
        })
        handleClose1()
        setActived(!actived)
        onFetchUsers()
      })
      .catch((error) => {
        swal({
          title: error.response.data.message,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  CustomUseEffect(() => {
    const detailRole = async () => {
      await getDetailRole(roles).then((res: any) => {
        let data = res.data.data.sales_orgs
        setSales(res.data.data.sales_org_code)
      })
    }
    detailRole()
  }, [roles])

  CustomUseEffect(() => {
    const listSales = async () => {
      await getUserLevelSorg(sales).then((res: any) => {
        setSalesList(res.data.data)
      })
    }
    listSales()
  }, [sales])

  // =======================================================

  CustomUseEffect(() => {
    const detailRoleEdit = async () => {
      await getDetailRole(editRoles).then((res: any) => {
        setSalesEdit(res.data.data.sales_org_code)
      })
    }
    detailRoleEdit()
  }, [editRoles])

  CustomUseEffect(() => {
    const listSalesEdit = async () => {
      await getUserLevelSorg(salesEdit).then((res: any) => {
        setSalesListEdit(res.data.data)
      })
    }
    listSalesEdit()
  }, [salesEdit])

  CustomUseEffect(() => {
    let test: any = sectors.find((o: any) => o.value == 1 || o.value == 2 || o.value == 4)
    if (test?.value == 2 || test?.value == 1 || test?.value == 4) setIsExport(false)
    else setIsExport(true)

    getSegments()

  }, [sectors])

  CustomUseEffect(() => {
    let test: any = editSector.find((o: any) => o.value == 1 || o.value == 2 || o.value == 4)
    if (test?.value == 2 || test?.value == 1 || test?.value == 4) setIsExport2(false)
    else setIsExport2(true)

    getSegmentsEdit()
  }, [editSector])

  CustomUseEffect(() => {
    setGetRegions([])
  }, [isExport])

  CustomUseEffect(() => {
    setEditRegion([])
    setCounter(counter + 1)
  }, [isExport2])

  const [counter, setCounter] = useState(0)

  CustomUseEffect(() => {
    setEditCity([])
    setOptionEdit(null)
  }, [counter])

  CustomUseEffect(() => {
    setSelected([])
    setOption(null)
  }, [getregions])

  //#region state for search
  const [position, setPosition] = useState('')
  const [actived, setActived] = useState(false)

  useEffect(() => {
    const getData = setTimeout(onFetchUsers, 1000)
    return () => clearTimeout(getData)
  }, [onFetchUsers])
  //#endregion

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterUser({...filterUser, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterUser())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  const gettemplate = async () => {
    try {
      setIsDownloadTemplate(true)
      const response = await downloadTemplate();
      const href = URL.createObjectURL(response.data)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `user_template.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setIsDownloadTemplate(false)
    } catch (error) {
      setIsDownloadTemplate(false)
      swal({
        title: t('Donwload Failed'),
        icon: 'error',
      })
    }
  }

  const roleUser: any = localStorage.getItem('role-flag')

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterUser?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          hakAkses?.create && (
            <>
              <button
                disabled={isDownloadTemplate}
                className='btn btn-info me-2'
                title={t('Download Template')}
                onClick={() => gettemplate()}
              >
                {isDownloadTemplate ? (
                  <Spinner animation='border' variant='light' size='sm' /> 
                ) : 
                  <KTSVG path='/media/icons/duotune/download.svg' />
                }
                {t('Download Template')}
              </button>
              <button
                onClick={() => {
                  setShowUpload(true)
                }}
                className='btn btn-warning me-2'
                title={t('Import')}
              >
                <KTSVG path='/media/icons/duotune/cloud-arrow-up-fill.svg' />
                {t('Import')}
              </button>
              <button
                className='btn btn-primary'
                onClick={() => {
                  clearState()
                  handleShow()
                }}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                {t('addUser')}
              </button>
            </>
          )
        }
      />

      {hakAkses?.read && (
        <>
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <tr>
                  <th>{t('No')}</th>
                  <th>{t('nama')}</th>
                  <th>{t('position')}</th>
                  <th>{t('username')}</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>{t('kontrak-aksi')}</th>
                </tr>
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter />
                {loading ? (
                  <RowLoader />
                ) : isError ? (
                  <RowErrorFetch />
                ) : users?.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  users?.map((item: any, index: number) => (
                    <tr key={item?.id ?? index}>
                      <td>{index + 1 + rowNumber}</td>
                      <td>{item.name}</td>
                      <td>{item.position}</td>
                      <td>{item.nama_pengguna}</td>
                      <td>{item.email}</td>
                      <td>{item.role?.name?.replace(/ for /i, ' ' + t('untuk') + ' ')}</td>
                      <td>
                        <div className='d-flex justify-content-center'>
                          {hakAkses?.update && (
                            <button
                              onClick={() => handleEdit(item.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 ms-3'
                              title={t('ubah')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}

                          {hakAkses?.delete && (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title={t('Hapus')}
                              onClick={() => deleteUser(item.id)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}

                          {roleUser == 'admin' && (
                            <button
                              className='btn btn-icon btn-primary btn-sm ms-2'
                              title='Login as'
                              onClick={() => impersonateUser(item.nama_pengguna)}
                            >
                              <i className='fas fa-sign-in'></i>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>

          <Pagination paginate={paginateNumber} test={numberURL} />
        </>
      )}

      <Modal
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Import')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td style={{width: '120px'}}>
                <h6>{t('order-fileUnggah')}</h6>
              </td>
              <td className='w-75'>
                <InputFile
                    setFileName={(_: string) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
              </td>
            </tr>
          </table>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='w-100 '
              onClick={() => handleUpload()}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose1}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingg ? (
            <>
              <div className='d-flex justify-content-center'>
                <Spinner animation='border' variant='primary' />
              </div>
            </>
          ) : (
            <>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('nama')}</Form.Label>
                <Form.Control
                  type='text'
                  value={editName}
                  onChange={(e: any) => setEditName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('position')}</Form.Label>
                <Form.Control
                  type='text'
                  value={editPosition}
                  onChange={(e: any) => setiEditPosition(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('username')}</Form.Label>
                <Form.Control
                  type='text'
                  value={editUsername}
                  onChange={(e: any) => setEditUsername(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type='text'
                  value={editEmail}
                  onChange={(e: any) => setEditEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('New-Password')}</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Password'
                  onChange={(e: any) => setGetPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('Konfirmasi')} Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Password'
                  onChange={(e: any) => setConfirm(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('Phone Number')}</Form.Label>
                <div className='d-flex'>
                  <Form.Control
                    className='me-2'
                    style={{width: '15%'}}
                    type='text'
                    value='+62'
                    disabled
                  />
                  <Form.Control
                    type='Number'
                    placeholder={t('Phone Number')}
                    defaultValue={editphone}
                    onChange={(e: any) => {
                      setEditPhone(e.target.value)
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('Sektor')}</Form.Label>
                <MultiSelect
                  options={sector?.map((item: any) => {
                    return {label: t(item.name), value: item.id}
                  })}
                  value={editSector}
                  onChange={setEditSector}
                  labelledBy='Select'
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
              <Form.Label>{t('segment')}</Form.Label>
                <MultiSelect
                  options={fullSegment?.map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  value={fullSegment.filter((item: any) => {
                    return segments.map((it: any) => it.value).includes(item.code)
                  }).map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  onChange={setSegments}
                  labelledBy='Select'
                />
              </Form.Group>
              {!isExport2 ? (
                <>
                  <Form.Group className='mb-5' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-wilayah')}</Form.Label>
                    <MultiSelect
                      key={editSector}
                      options={region}
                      value={editRegion}
                      onChange={handleRegionEdit}
                      labelledBy='Select'
                    />
                  </Form.Group>
                  <Form.Group className='mb-5' controlId='formBasicEmail'>
                    {optionEdit != null ? (
                      <>
                        <Form.Label>{t('sub-order-kota')}</Form.Label>
                        <MultiSelect
                          key={editRegion}
                          options={optionEdit}
                          value={editCity}
                          onChange={setEditCity}
                          labelledBy='Select'
                        />
                      </>
                    ) : null}
                  </Form.Group>
                </>
              ) : (
                ''
              )}
              {/* <Form.Group className='mb-5' controlId='formBasicEmail'>
                                        <Form.Label>Sales Org</Form.Label>
                                        {salesOrg != null ? (
                                          <MultiSelect
                                            options={salesOrg?.map((item: any) => {
                                              return { label: item.name, value: item.code }
                                            })}
                                            value={editSales}
                                            onChange={setEditSales}
                                            labelledBy='Select'
                                          />
                                        ) : null}
                                      </Form.Group> */}
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>Role</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='code'
                  onChange={(e: any) => setEditRoles(e.target.value)}
                >
                  <option selected hidden value={editRoles}>
                    {editRolesName}
                  </option>
                  {role?.map((roles: any) => (
                    <>
                      {editRolesName == roles.name ? (
                        <option selected value={editRoles}>
                          {editRolesName}
                        </option>
                      ) : (
                        <option value={roles.id}>
                          {roles.name?.replace(/ for /i, ' ' + t('untuk') + ' ')}
                        </option>
                      )}
                    </>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>User Level</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='code'
                  onChange={(e: any) => setEditLevel(e.target.value)}
                >
                  <option value=''>{t('pilih')} User Level</option>
                  {salesListEdit?.map((item: any) => (
                    <>
                      {editLevelName == item.name ? (
                        <option selected value={editLevel}>
                          {editLevelName}
                        </option>
                      ) : (
                        <option value={item.id}>{item.name}</option>
                      )}
                    </>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('Product-Type')}</Form.Label>
                <MultiSelect
                  options={material?.map((item: any) => {
                    return {
                      label: t(item.material_group_desc),
                      value: item.material_group,
                    }
                  })}
                  value={editProduct}
                  onChange={setEditProduct}
                  labelledBy='Select'
                />
              </Form.Group>

              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={editUser} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('ubah')
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-tambah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('nama')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('nama')}
              onChange={(e: any) => setGetName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('position')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('position')}
              onChange={(e: any) => setPosition(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('username')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('username')}
              onChange={(e: any) => setGetUsername(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='text'
              placeholder='Email'
              onChange={(e: any) => setGetEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Password'
              onChange={(e: any) => setGetPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label> {t('Konfirmasi')} Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Password'
              onChange={(e: any) => setConfirm(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Phone Number')}</Form.Label>
            <div className='d-flex'>
              <Form.Control
                className='me-2'
                style={{width: '15%'}}
                type='text'
                value='+62'
                disabled
              />
              <Form.Control
                type='number'
                placeholder={t('Phone Number')}
                onChange={(e: any) => {
                  setPhone(e.target.value)
                }}
              />
            </div>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Sektor')}</Form.Label>
            <MultiSelect
              options={sector?.map((item: any) => {
                return {label: t(item.name), value: item.id}
              })}
              value={sectors}
              onChange={setSectors}
              labelledBy='Select'
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('segment')}</Form.Label>
            <MultiSelect
              options={fullSegment?.map((item: any) => {
                return {label: t(item.name), value: item.code}
              })}
              value={segments}
              onChange={setSegments}
              labelledBy='Select'
            />
          </Form.Group>
          {!isExport ? (
            <>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('kontrak-wilayah')}</Form.Label>
                <MultiSelect
                  options={region.map((item: any) => {
                    return {
                      value: item.value,
                      label: item.label,
                    }
                  })}
                  value={getregions}
                  key={sectors}
                  onChange={handleRegion}
                  labelledBy='Select'
                />
              </Form.Group>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                {option != null ? (
                  <>
                    <Form.Label>{t('sub-order-kota')}</Form.Label>
                    <MultiSelect
                      options={option?.map((item: any) => {
                        return {label: item.value, value: item.id}
                      })}
                      value={selected}
                      key={regions}
                      onChange={setSelected}
                      labelledBy='Select'
                    />
                  </>
                ) : null}
              </Form.Group>
            </>
          ) : (
            ''
          )}
          {/* <Form.Group className='mb-5' controlId='formBasicEmail'>
                    <Form.Label>Sales Org</Form.Label>
                    {salesOrg != null ? (
                      <MultiSelect
                        options={salesOrg?.map((item: any) => {
                          return { label: item.name, value: item.code }
                        })}
                        value={getSaleses}
                        onChange={handleChange}
                        labelledBy='Select'
                      />
                    ) : null}
                  </Form.Group> */}
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Role</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='code'
              onChange={(e: any) => {
                setRoles(e.target.value)
              }}
            >
              <option>{t('pilih')} Role</option>
              {role?.map((roles: any) => (
                <option key={roles.id} value={roles.id}>
                  {roles.name?.replace(/ for /i, ' ' + t('untuk') + ' ')}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>User Level</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='code'
              onChange={(e: any) => setLevels(e.target.value)}
            >
              <option value=' '>{t('pilih')} User Level</option>
              {salesList?.map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Product-Type')}</Form.Label>
            <MultiSelect
              options={material?.map((item: any) => {
                return {label: t(item.material_group_desc), value: item.material_group}
              })}
              value={materials}
              onChange={setMaterials}
              labelledBy='Select'
            />
          </Form.Group>

          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={postUser} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-tambah')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableUser}
